<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Refund Policy</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Refund policy</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <button class="btn btn-info" @click="goback()">
                  <!-- <i class="fa fa-filter"></i> -->
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- <h3>Refund policy</h3> -->
          <p>
            Once the customer paid for connection, refund will be processed as
            per the following policies –
          </p>
          <ol>
            <li>
              Refund will be made within 10 working days after service
              cancellation by the subscriber.
            </li>
            <li>
              Bank or Payment Gateway charge may be deducted subject to the
              terms and conditions of the relevant Bank or Payment Gateway.
            </li>
            <li>
              Once installation is done, installation fee will be deducted from
              refund amount.
            </li>
          </ol>
        </div>

        <div class="row">
          <h4>Delivery Policy</h4>
          <p>
            Carnival shall provide the services to the subscriber within 3
            working days. However, in case of any delay, Carnival will notify
            the subscriber as soon as it is reasonably practicable.
          </p>
        </div>

        <div class="row">
          <h4>Cancellation Policy</h4>
          <p>
            Cancellation of request for connection will be allowed for the
            following reasons -
          </p>
          <ol>
            <li>
              Location of the customer is out of coverage of {{ companyName }}
            </li>
            <li>
              Technical issues at the customer’s end which renders providing
              connection unfeasible
            </li>
            <li>Change of decision by the customer</li>
          </ol>
        </div>
        <br />

        <div class="row">
          <h4>Contact us</h4>
          <p>
            If you have questions, concerns or suggestions related to our
            Privacy Policy or our privacy practices you may write to us at
            <a href="mailto:info@carnival.com.bd"> info@carnival.com.bd </a>
            or Uday Tower, Level 12, 57 &#38; 57/A, Gulshan Avenue, Dhaka-1212.
          </p>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Ticket History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    fields: {
      current_password: "",
      new_password: "",
      retype_password: "",
    },
    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find(".push-menu-class").trigger("click");
    // }
    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },

    OpenTicket() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/open-ticket";
          let method = "POST";
          console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.is_loading = false;
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              //alert("Error happend!");
              // console.log("Errors:::", errors);
              //console.log("Errors:::", response);
              console.log(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
              //   _this.$setErrorsFromResponse(errors.response.data.errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() {},

    getUsers() {},

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
